import { Link } from "react-router-dom";
import { euro, imgSrc } from "@/lib/api";

const LETTERS = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "2XL", "XXXL", "3XL", "4XL"];
const sizeKey = (s) => {
  const n = parseFloat(String(s).replace(",", "."));
  if (!Number.isNaN(n)) return [0, n];
  const i = LETTERS.indexOf(String(s).toUpperCase());
  return i >= 0 ? [1, i] : [2, 0];
};
export const sortSizes = (list) => [...list].sort((a, b) => {
  const [x, y] = [sizeKey(a), sizeKey(b)];
  return x[0] - y[0] || x[1] - y[1] || String(a).localeCompare(String(b));
});

const SizeChips = ({ product, active }) => {
  const sizes = sortSizes([...new Set(product.sizes.filter((s) => s.stock > 0).map((s) => s.size))]);
  if (!sizes.length) return null;
  const shown = sizes.slice(0, 8);
  if (active && sizes.includes(active) && !shown.includes(active)) shown[7] = active;
  return (
    <div className="mt-2 flex flex-wrap gap-1" data-testid={`product-sizes-${product.id}`}>
      {shown.map((s) => (
        <span key={s} className={`min-w-[28px] h-6 px-1.5 border text-[11px] font-semibold grid place-items-center ${s === active ? "bg-brand text-white border-brand" : "border-brand/40 text-brand-dark"}`}>{s}</span>
      ))}
      {sizes.length > shown.length && <span className="h-6 px-1 text-[11px] text-slate-500 grid place-items-center">+{sizes.length - shown.length}</span>}
    </div>
  );
};

export const ProductCard = ({ product, index = 0, size = "" }) => {
  const stock = product.sizes.reduce((s, x) => s + x.stock, 0);
  const off = product.compare_price && product.compare_price > product.price;
  return (
    <Link
      to={`/producto/${product.id}${size ? `?size=${encodeURIComponent(size)}` : ""}`}
      className="group block fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-white border border-slate-100">
        <img src={imgSrc(product.images?.[0] || Object.values(product.color_images || {})[0]?.[0], 600)} alt={product.name} loading="lazy" className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute top-3 left-3 flex flex-col gap-1">
          {off && <span className="tag bg-brand text-white">-{Math.round((1 - product.price / product.compare_price) * 100)}%</span>}
          {stock === 0 && <span className="tag bg-slate-900 text-white">Agotado</span>}
          {stock > 0 && stock <= 3 && <span className="tag bg-amber-400 text-slate-900">Últimas unidades</span>}
        </div>
      </div>
      <div className="pt-4 flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-slate-500 truncate">{product.brand || product.category}</p>
          <h3 className="mt-1 font-bold tracking-tight break-words group-hover:text-brand transition-colors">{product.name}</h3>
        </div>
        <div className="text-right shrink-0">
          <p className="font-bold" data-testid={`product-price-${product.id}`}>{euro(product.price)}</p>
          {off && <p className="text-xs text-slate-400 line-through">{euro(product.compare_price)}</p>}
        </div>
      </div>
      <SizeChips product={product} active={size} />
    </Link>
  );
};
